<template>
  <b-modal id="folio-modal" :title="$t('menu.folio', 'Folio')" size="lg" ok-only>
    <template #modal-title>
      <div class="folio-modal-title">
        <span class="title-label">
          {{ $t('menu.folio', 'Folio') }}
        </span>
        <span class="title-meta">
          {{ $t('Purchased charts and services') }}
        </span>
      </div>
    </template>
    <b-tabs
        content-class="mt-3"
        nav-class="folio-tabs"
        active-nav-item-class="folio-tab-active"
    >
      <!-- Вкладка ENC S-63 (данные поставщика Primar - ячейки карт S63 ENC) -->
  <b-tab title="ENC S-63" title-link-class="folio-tab-link">
        <div v-if="s63Items.length" class="tab-content">
          <div class="modal-section">
            <b-table
                size="sm"
                :items="paginatedS63Items"
                :fields="folioFields"
                head-variant="light"
                class="styled-table"
                responsive="md"
            >
              <template #cell(createdUtc)="data">
                {{ formatDate(data.value) }}
              </template>
              <template #cell(daysLeft)="row">
                <span
                    :class="['days-chip', row.item.daysLeftClass]"
                >
                  {{ row.item.daysLeft }} days
                </span>
              </template>
            </b-table>
          </div>
          <b-pagination
              v-model="pagination.s63"
              :total-rows="s63Items.length"
              :per-page="perPage"
              align="center"
              size="sm"
              class="styled-pagination mt-3"
          />
        </div>
        <div v-else class="empty-state">
          <p class="text-muted">
            No ENC S-63 data purchased
          </p>
        </div>
      </b-tab>

      <!-- Вкладка ENC S-102 (данные поставщика Primar - карты S102) -->
  <b-tab title="ENC S-102" title-link-class="folio-tab-link">
        <div v-if="s102Items.length" class="tab-content">
          <div class="modal-section">
            <b-table
                size="sm"
                :items="paginatedS102Items"
                :fields="folioFields"
                head-variant="light"
                class="styled-table"
                responsive="md"
            >
              <template #cell(createdUtc)="data">
                {{ formatDate(data.value) }}
              </template>
              <template #cell(daysLeft)="row">
                <span
                    :class="['days-chip', row.item.daysLeftClass]"
                >
                  {{ row.item.daysLeft }} days
                </span>
              </template>
            </b-table>
          </div>
          <b-pagination
              v-model="pagination.s102"
              :total-rows="s102Items.length"
              :per-page="perPage"
              align="center"
              size="sm"
              class="styled-pagination mt-3"
          />
        </div>
        <div v-else class="empty-state">
          <p class="text-muted">
            No ENC S-102 data purchased
          </p>
        </div>
      </b-tab>

      <!-- Вкладка AVCS S-63 (данные поставщика UKHO/MSS - ячейки карт AVCS) -->
      <!-- <b-tab title="AVCS S-63">
        <template v-if="avcsItems.length">
          <b-table size="sm" :items="avcsItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'AVCS maps')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'AVCS maps')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No AVCS S-63 data purchased</p>
          </div>
        </template>
      </b-tab> -->

      <!-- Вкладка ADP (данные поставщика UKHO/MSS - публикации ADP) -->
      <!-- <b-tab title="ADP">
        <template v-if="adpItems.length">
          <b-table size="sm" :items="adpItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'ADP')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'ADP')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No ADP data purchased</p>
          </div>
        </template>
      </b-tab> -->

      <!-- Вкладка eNP (данные поставщика UKHO/MSS - публикации eNP) -->
      <!-- <b-tab title="eNP">
        <template v-if="enpItems.length">
          <b-table size="sm" :items="enpItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'ENP')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'ENP')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No eNP data purchased</p>
          </div>
        </template>
      </b-tab> -->

      <!-- Вкладка Navarea (данные поставщика UKHO/MSS - навигационные предупреждения по районам) -->
  <b-tab title="Navarea" title-link-class="folio-tab-link">
        <div v-if="navareaItems.length" class="tab-content">
          <div class="modal-section">
            <b-table
                size="sm"
                :items="paginatedNavareaItems"
                :fields="folioFields"
                head-variant="light"
                class="styled-table"
                responsive="md"
            >
              <template #cell(createdUtc)="data">
                {{ formatDate(data.value) }}
              </template>
              <template #cell(daysLeft)="row">
                <span
                    :class="['days-chip', row.item.daysLeftClass]"
                >
                  {{ row.item.daysLeft }} days
                </span>
              </template>
            </b-table>
          </div>
          <b-pagination
              v-model="pagination.navarea"
              :total-rows="navareaItems.length"
              :per-page="perPage"
              align="center"
              size="sm"
              class="styled-pagination mt-3"
          />
        </div>
        <div v-else class="empty-state">
          <p class="text-muted">
            No Navarea data purchased
          </p>
        </div>
      </b-tab>

      <!-- Вкладка AIO (данные поставщика UKHO/MSS - данные Admirality Overlay Information) -->
      <!-- <b-tab title="AIO">
        <template v-if="aioItems.length">
          <b-table size="sm" :items="aioItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'AIO')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'AIO')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No AIO data purchased</p>
          </div>
        </template>
      </b-tab> -->
        <div class="text-center mt-3">
      <b-link class="table-link" @click="goToFolio">
        Go to folio
      </b-link>
    </div>

    </b-tabs>
  </b-modal>
</template>

<script>
export default {
  props: {
    folio: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      folioFields: [
        { key: 'id', label: 'Item', tdClass: 'text-left', sortable: true },
        { key: 'period', label: 'Period', tdClass: 'text-left' },
        { key: 'paymentMethod', label: 'Payment Method', tdClass: 'text-left' },
        { key: 'createdUtc', label: 'Order Date', tdClass: 'text-left', sortable: true },
        { key: 'daysLeft', label: 'Days left', tdClass: 'text-left', sortable: true },
      ],
      perPage: 10,
      pagination: {
        s63: 1,
        s102: 1,
        navarea: 1,
        avcs: 1,
        adp: 1,
        enp: 1,
        aio: 1,
      },
    }
  },

  computed: {
    paginatedS63Items() {
      return this.paginate(this.s63Items, 's63')
    },

    paginatedS102Items() {
      return this.paginate(this.s102Items, 's102')
    },

    paginatedNavareaItems() {
      return this.paginate(this.navareaItems, 'navarea')
    },

    // Получение ячеек карт в формате S63 ENC от Primar
    s63Items() {
      return this.getUniqueItemsByType('s63 maps')
    },

    // Получение ячеек карт в формате S102 ENC
    s102Items() {
      return this.getUniqueItemsByType('s102 maps')
    },

    // Получение ячеек карт в формате AVCS от UKHO/MSS
    avcsItems() {
      return this.getUniqueItemsByType('AVCS maps')
    },

    // Получение публикаций ADP от UKHO/MSS
    adpItems() {
      return this.getUniqueItemsByType('ADP')
    },

    // Получение публикаций eNP от UKHO/MSS
    enpItems() {
      return this.getUniqueItemsByType('ENP')
    },

    // Получение данных Navarea (навигационные предупреждения по районам)
    navareaItems() {
      return this.getUniqueItemsByType('Navarea')
    },

    // Получение данных AIO (All In One)
    aioItems() {
      return this.getUniqueItemsByType('AIO')
    },
  },
  methods: {
    // Возвращает отфильтрованный массив с учетом пагинации
    paginate(items, key) {
      const totalPages = Math.max(1, Math.ceil(items.length / this.perPage))
      const current = this.pagination[key] || 1

      if (!this.pagination[key]) {
        this.$set(this.pagination, key, 1)
      }

      if (current > totalPages) {
        this.$set(this.pagination, key, totalPages)
      }

      const activePage = this.pagination[key] || 1
      const start = (activePage - 1) * this.perPage
      return items.slice(start, start + this.perPage)
    },

        // Переход к странице транзакций
    goToFolio() {
      this.$bvModal.hide('folio-modal');
      this.$router.push('/ship-folio');
    },

    // Получение уникальных элементов по типу с выбором последнего актуального заказа
    getUniqueItemsByType(itemType) {
      const map = new Map()

      this.folio.forEach(order => {
        if (!order || !Array.isArray(order.items)) return

        order.items.forEach(item => {
          if (!item || item.type !== itemType || !item.id) return

          const monthCount = item.monthCount || 0
          const createdUtc = order.createdUtc || ''
          const paymentMethod = order.paymentMethod || '—'
          const daysLeft = this.calculateDaysLeft(createdUtc, monthCount)
          let daysLeftClass = this.getDaysLeftClass(createdUtc, monthCount)

          if (!daysLeftClass) {
            daysLeftClass = daysLeft > 0 ? 'days-good' : 'days-critical'
          }

          const candidate = {
            id: item.id,
            period: this.formatPeriod(monthCount),
            paymentMethod,
            createdUtc,
            daysLeft,
            daysLeftClass,
          }

          const existing = map.get(item.id)

          const existingCreated = existing?.createdUtc ? new Date(existing.createdUtc) : null
          const candidateCreated = createdUtc ? new Date(createdUtc) : null

          const existingTime = existingCreated && !Number.isNaN(existingCreated.getTime())
            ? existingCreated.getTime()
            : null
          const candidateTime = candidateCreated && !Number.isNaN(candidateCreated.getTime())
            ? candidateCreated.getTime()
            : null

          const isFresher = candidateTime !== null && existingTime !== null
            ? candidateTime > existingTime
            : candidateTime !== null && existingTime === null

          if (
            !existing
            || candidate.daysLeft > existing.daysLeft
            || (candidate.daysLeft === existing.daysLeft && isFresher)
          ) {
            map.set(item.id, candidate)
          }
        })
      })

      return Array.from(map.values()).sort((a, b) => {
        if (b.daysLeft !== a.daysLeft) {
          return b.daysLeft - a.daysLeft
        }

        const aTimeRaw = a.createdUtc ? new Date(a.createdUtc).getTime() : Number.NEGATIVE_INFINITY
        const bTimeRaw = b.createdUtc ? new Date(b.createdUtc).getTime() : Number.NEGATIVE_INFINITY

        const aTime = Number.isFinite(aTimeRaw) ? aTimeRaw : Number.NEGATIVE_INFINITY
        const bTime = Number.isFinite(bTimeRaw) ? bTimeRaw : Number.NEGATIVE_INFINITY

        if (bTime !== aTime) {
          return bTime - aTime
        }

        return (a.id || '').localeCompare(b.id || '')
      })
    },

    // Фильтрация элементов по типу (используется в закомментированных секциях)
    getFilteredItems(items, itemType) {
      if (!Array.isArray(items)) return []
      return items.filter(item => item && item.type === itemType)
    },

    // Форматирование периода действия
    formatPeriod(monthCount) {
      if (!monthCount || monthCount <= 0) return '—'
      const suffix = monthCount === 1 ? 'month' : 'months'
      return `${monthCount} ${suffix}`
    },

    // Форматирование даты в удобочитаемый формат
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },

    // Расчет оставшихся дней до окончания действия подписки
    calculateDaysLeft(startDate, monthCount) {
      if (!startDate || !monthCount || monthCount <= 0) return 0

      const start = new Date(startDate)
      const end = new Date(start)
      end.setMonth(end.getMonth() + monthCount)

      const now = new Date()
      const daysLeft = Math.floor((end - now) / (1000 * 60 * 60 * 24))

      return daysLeft > 0 ? daysLeft : 0
    },

    // Получение CSS класса для отображения оставшихся дней
    getDaysLeftClass(startDate, monthCount) {
      if (!startDate || !monthCount || monthCount <= 0) return ''

      const daysLeft = this.calculateDaysLeft(startDate, monthCount)

      if (daysLeft < 1) return 'days-critical'
      if (daysLeft <= 30) return 'days-warning'
      return 'days-good'
    },

  },
}
</script>

<style scoped>
.modal-section {
  border: 1px solid #e4e8f5;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #fbfcff 0%, #f6f8ff 100%);
  box-shadow: 0 4px 16px rgba(34, 45, 80, 0.07);
}

.styled-table >>> thead tr {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 0.72rem;
  color: #5c6685;
  background: #eef1fb;
}

.styled-table >>> tbody tr {
  transition: transform 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;
}

.styled-table >>> tbody tr:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.09);
  background: #ffffff;
}

.styled-table >>> td {
  vertical-align: top;
  padding: 0.7rem;
  border-top: none;
  border-bottom: 1px solid #eef1fb;
  color: #1f2940;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
  font-size: 0.78rem;
  font-weight: 500;
  line-height: 1.35;
}

.tab-content {
  display: flex;
  flex-direction: column;
}

.styled-pagination >>> .page-link {
  border-radius: 999px !important;
  margin: 0 4px;
  padding: 6px 12px;
  border: 1px solid rgba(98, 111, 149, 0.25);
  background: rgba(255, 255, 255, 0.95);
  color: #1f2940;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  transition: all 0.18s ease;
  box-shadow: 0 1px 4px rgba(20, 29, 56, 0.08);
}

.styled-pagination >>> .page-item.active .page-link {
  background: linear-gradient(135deg, #f4f6ff, #e9edff);
  color: #2f3760;
  border-color: rgba(98, 111, 149, 0.35);
  box-shadow: 0 6px 14px rgba(31, 41, 64, 0.16);
}

.styled-pagination >>> .page-link:hover {
  color: #151b2c;
  box-shadow: 0 4px 10px rgba(31, 41, 64, 0.12);
}

.styled-pagination >>> .page-item.disabled .page-link {
  opacity: 0.5;
  box-shadow: none;
}

.days-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
  margin-top: 2px;
  text-transform: uppercase;
  box-shadow: inset 0 0 0 1px rgba(98, 111, 149, 0.12);
}

.days-good {
  background-color: #e3f5ea;
  color: #1f7a4d;
}

.days-warning {
  background-color: #fff4df;
  color: #a76200;
}

.days-critical {
  background-color: #ffe5e9;
  color: #a90021;
}

.empty-state {
  border: 1px dashed #cdd3e5;
  border-radius: 12px;
  padding: 24px 16px;
  text-align: center;
  background: #f8f9fe;
  color: #5c6685;
}

.folio-tabs >>> .nav-link,
.folio-tabs >>> .nav-link > span,
.folio-tabs >>> .folio-tab-link {
  border-radius: 999px;
  margin-right: 12px;
  padding: 0.5rem 1.25rem;
  color: #5c6685;
  transition: background-color 0.15s ease, color 0.15s ease;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em !important;
  text-transform: uppercase !important;
}

.folio-tab-link {
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em !important;
  text-transform: uppercase !important;
  color: #5c6685 !important;
}

.folio-tab-link.active,
.folio-tab-link.folio-tab-active {
  color: #ffffff !important;
}

.folio-tabs >>> .nav-link:hover,
.folio-tabs >>> .nav-link:hover > span,
.folio-tabs >>> .folio-tab-link:hover {
  background: #eef1fb;
  color: #1f2940;
}

.folio-tab-active >>> .nav-link,
.folio-tab-active >>> .folio-tab-link {
  background: #4b5fdd !important;
  color: #ffffff !important;
  box-shadow: 0 8px 18px rgba(75, 95, 221, 0.25);
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em !important;
  text-transform: uppercase !important;
}

.folio-tab-active >>> .nav-link > span,
.folio-tab-active >>> .folio-tab-link > span {
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em !important;
  text-transform: uppercase !important;
  color: #ffffff !important;
}

.folio-modal-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: 'Roboto', 'Helvetica Neue', 'Segoe UI', sans-serif;
}

.folio-modal-title .title-label {
  color: #1f2940;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.folio-modal-title .title-meta {
  color: #5b6480;
  font-size: 0.74rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.table-link {
  font-weight: 500;
  color: #3a4256;
  border-bottom: 1px dashed rgba(37, 45, 64, 0.65);
  padding-bottom: 1px;
  text-decoration: none;
  transition: color 0.2s ease;
}

.table-link:hover {
  color: #161b28;
}

::v-deep #folio-modal .modal-header {
  background: linear-gradient(135deg, #f4f6ff 0%, #e6e9ff 100%);
  border-bottom: none;
  padding: 18px 22px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: inset 0 -1px 0 rgba(98, 111, 149, 0.12);
}

::v-deep #folio-modal .modal-header .close {
  color: #4b5fdd;
  opacity: 0.75;
  text-shadow: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

::v-deep #folio-modal .modal-header .close:hover {
  opacity: 1;
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .modal-section {
    padding: 12px;
  }

  .styled-table >>> td {
    padding: 0.6rem;
  }
}
</style>
